import React from 'react';
import { withStyles, Grid, Typography, withRouter } from '../../../material-ui';

import MSectionHeader from '../../view/MSectionHeader';
import DataUtils from '../../../model/DataUtils';
import MatchType from '../../../model/MatchType';

class MatchPlayerMaterial extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            curIdex: 29,
            data: [],
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }



    _handleChange = (value) => {
        console.log('_handleChange', value);
        this.setState({ curIdex: value });
    }

    _renderItem = (img, name, value) => {
        return (
            <Grid container direction='row' justifyContent='space-between' style={{ paddingLeft: 8, paddingRight: 8, marginBottom: 8 }}>
                <Grid container direction='row' alignItems='center' style={{ flex: 1, paddingLeft: 8 }}>
                    <img src={img} alt='' style={{ width: 30, height: 30, objectFit: 'scale-down' }}></img>
                    <Typography style={{ fontSize: 12, color: '#0D0D0D', marginLeft: 16 }}>{name}</Typography>
                </Grid>
                <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>{value}</Typography>
            </Grid>
        );
    }

    _renderItem1 = (name, value, i) => {
        return (
            <Grid key={i} container direction='row' justifyContent='space-between' style={{ paddingLeft: 8, paddingRight: 8, marginBottom: 4 }}>
                <Typography style={{ fontSize: 12, color: '#878787', marginLeft: 16 }}>{name}</Typography>
                <Typography style={{ fontSize: 12, color: '#878787' }}>{value}</Typography>
            </Grid>
        );
    }

    _renderItem2 = (img, name, time, value) => {
        return (
            <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ paddingLeft: 8, paddingRight: 8, marginBottom: 16 }}>
                <Grid container direction='row' alignItems='center' style={{ flex: 1, paddingLeft: 8 }}>
                    <img src={img} alt='' style={{ width: 30, height: 30, objectFit: 'scale-down' }}></img>
                    <Grid container direction='column' alignItems='flex-start' style={{ flex: 1, paddingLeft: 8 }} >
                        <Typography style={{ fontSize: 12, color: '#0D0D0D', marginLeft: 8 }}>{name}</Typography>
                        <Typography style={{ fontSize: 12, color: '#878787', marginLeft: 8 }}>{time}</Typography>
                    </Grid>
                </Grid>
                <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>{value}</Typography>
            </Grid>
        );
    }

    render() {
        const { data, type_id } = this.props;
        const { team } = this.props.location.data;
        let age = '';
        let bheight = '';
        let weight = '';
        let position = '';
        let footName = '';
        let shirt_number = '';
        let teamUrl = '';
        let teamName = '';
        let saray = '';
        if (data) {
            age = data.age + '岁';
            bheight = data.height + 'cm';
            weight = data.weight + 'kg';
            position = DataUtils.getPositionName(data.position, type_id);
            footName = DataUtils.getFootName(data.preferred_foot)
            if (data.shirt_number) {
                shirt_number = data.shirt_number + '号';
            }
            if (team) {
                if (team.logo && team.logo.startsWith('http')) {
                    teamUrl = team.logo;
                } else {
                    let HttpUrlTeam = 'https://cdn.sportnanoapi.com/football/team/';
                    teamUrl = HttpUrlTeam + team.logo;
                }
                teamName = team.name_zh;
            }
            if (data.market_value_currency) {
                saray = data.market_value_currency + data.market_value;
            } else {
                if (data.market_value) {
                    saray = data.market_value;
                } else {
                    saray = data.salary;
                }
            }

        }

        let datas = [];
        if (type_id == MatchType.BASKETBALL) {
            datas.push({ key: '年龄', value: age });
            datas.push({ key: '身高', value: bheight });
            datas.push({ key: '体重', value: weight });
            datas.push({ key: '主要位置', value: position });
            datas.push({ key: '球衣', value: shirt_number });
        } else if (type_id == MatchType.FOOTBALL) {
            datas.push({ key: '年龄', value: age });
            datas.push({ key: '身高', value: bheight });
            datas.push({ key: '体重', value: weight });
            datas.push({ key: '惯用脚', value: footName });
            datas.push({ key: '主要位置', value: position });
        }

        let history = [];


        return (
            <Grid style={{ width: '100%' }}>
                <Grid style={{ width: '100%', height: 1, backgroundColor: '#F2F2F2' }}></Grid>
                <Grid style={{ width: '100%', height: 16, }}></Grid>
                {
                    this._renderItem(teamUrl, teamName, saray)
                }
                <Grid style={{ width: '100%', height: 16, }}></Grid>
                {
                    datas.map((item, i) => (
                        this._renderItem1(item.key, item.value, i)
                    ))
                }
                <MSectionHeader title='转会历史' />
                {
                    history.map((item, i) => (
                        this._renderItem2('https://duihui.duoduocdn.com/zuqiu/liwupu.png', '尤文图斯', '2018-06-30', '11700万欧元')
                    ))
                }
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    button: {
        fontSize: 12,
        backgroundColor: '#FC182B',
        color: '#FFF',
        borderRadius: 4,
        width: 75,
        height: 25,
    },
    tableBodyCell1: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#FC182B'
    },
    tableBodyCell: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#0d0d0d'
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
    }
}))(MatchPlayerMaterial));